// Dependencies
import loMerge from "lodash.merge";

/**
 * Thin wrapper around lodash.merge to merge objects.
 * https://lodash.com/docs/#merge
 *
 * Use cases:
 * - Merging search params
 */
export const mergeObjects = <TObject, TSource>(destination: TObject, source: TSource): TObject & TSource => {
	return loMerge({}, destination, source);
};
